import { inject } from '@angular/core';
import { StationsService } from '../../../services';
import { CheckoutCompleteNavExtras } from '../../../models';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

/** when extending this class be sure to implement ngOnInit */
export class NgxAimStationComplete {
  // ngOnInit() {
  //   this.init();
  // }

  stationsService = inject(StationsService);
  location = inject(Location);
  router = inject(Router);

  selectedGroup = this.stationsService.getSelectedGroup();
  selectedStation = this.stationsService.getSelectedStation();
  selectedTime = this.stationsService.getSelectedTime();
  selectedDate = this.stationsService.getSelectedDate();
  selectedDuration = this.stationsService.getSelectedDuration();
  selectedAmountOfGuests = this.stationsService.getSelectedAmountOfGuests();
  Notes = this.stationsService.Notes;
  allowedGuestMessage = this.stationsService.allowedGuetsMessage;
  orderId = 0;
  duration = this.stationsService.getSelectedDuration()! / 60;

  constructor() {
    const state = this.location.getState() as CheckoutCompleteNavExtras;
    if (state?.orderId) {
      this.orderId = +state.orderId;
    } else {
      this.router.navigateByUrl('/');
    }
  }

  init() {
    this.stationsService.reset();
  }
}